module.exports = __webpack_public_path__ + "static/img/csss_chi_1.cf919109.jpg";